import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill="#202020" fillOpacity="0.5" d="M8 8.818L11.89 5 13 6.09 8 11 3 6.09 4.11 5 8 8.818z"></path>
    </svg>
  )
}

export default Icon
